// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"303":"2c3c27b9","702":"a23f7f09","968":"1083eff8"}[chunkId] + ".chunk.css";
};